<template>
  <section id="login">
    <page-title :title="title"></page-title>
    <div class="login-content">
      <div v-if="!resetPasswordMode">
        <div>
          <form @submit.prevent="onLogin" v-on:keyup.enter="onLogin">
            <div class="form-field">
              <label for="email">Email</label>
              <input id="email" type="email" v-model="email" :placeholder="placeholder" required />
            </div>
            <div class="form-field">
              <label for="password">Password</label>
              <input id="password" type="password" v-model="password" required />
            </div>
            <div>
              <primary-button :title="signInText" :act="onLogin"></primary-button>
            </div>
          </form>
        </div>

        <div>
          {{forgotPassMsg}}
          <div class="reset-pass" @click="openResetPassword">{{forgotPassLink}}</div>
        </div>
        <div class="to-signup">
          {{toSignupMsg}}<router-link to="/signup">{{toSignupLink}}</router-link>
        </div>
      </div>

      <div v-if="resetPasswordMode">
        <div>
          <form @submit.prevent="sendResetEmail">
            <div class="form-field">
              <label for="email">Email</label>
              <input id="email" type="email" v-model="email" :placeholder="placeholder" required />
            </div>
            <div>
              <primary-button :title="'Send reset link'" :act="sendResetEmail"></primary-button>
            </div>
          </form>
        </div>
        <div class="to-signin">
          {{cancelResetMsg}} <div @click="closeResetPassword">{{cancelResetLink}}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from "firebase";
import api from "../api";
import bus from "../bus";
import PageTitle from "@/components/PageTitle";
import PrimaryButton from "@/components/shared/PrimaryButton";

export default {
  name: "signup",
  data() {
    return {
      email: "",
      password: "",
      title: "Log in",
      placeholder: "e.g. emma@janeausten.com",
      signInText: "Log in",
      toSignupMsg: "Don't have an account? ",
      toSignupLink: "Sign up",
      forgotPassMsg: "Forgot your password? ",
      forgotPassLink: "Change it",
      cancelResetMsg: "or, go back to ",
      cancelResetLink: "Log in",
      resetPasswordMode: false,
    };
  },
  components: {
    PageTitle,
    PrimaryButton,
  },
  methods: {
    onLogin: function () {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            api.createEventTracking("user-login", "access", this.email, true);

            this.$router.push("/ideas"); // redirect to MyIdeas
          },
          (err) => {
            alert(err.message);
          }
        );
    },
    openResetPassword: function () {
      this.resetPasswordMode = true;
      this.title = "Reset your password";
    },
    closeResetPassword: function () {
      this.resetPasswordMode = false;
      this.title = "Sign in";
    },
    sendResetEmail: function () {
      var auth = firebase.auth();

      auth
        .sendPasswordResetEmail(this.email)
        .then(() => {
          // Email sent.
          this.email = "";
          this.closeResetPassword();
        })
        .catch(function (error) {
          this.$rollbar.error(error);
          alert("An error occured while resetting your password. Please try again later.");
        });
    },
  },
  mounted() {
    bus.$emit("hide-loader");
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

@import "@/styles/form.scss";

.page-title {
  margin-bottom: 40px;
}

.form-field,
.primary-button {
  margin-bottom: 16px;
}

.form-field > * {
  display: block;
}

.to-signup {
  margin-top: 8px;
  color: theme.$text-color;
}

.to-signup a,
.reset-pass,
.to-signin div {  
  font-weight: theme.$font-weight-bold;
  color: theme.$primary-color;
  display: inline-block;
}

@media (min-width: 768px) {
  .login-content {
    padding: 40px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: auto;
    max-width: 450px;
  }
  #app {
    margin-left: 0;
  }
}
</style> 